import Meta from '@/components/common/Meta'

import CheapStoragePlacesPage from '@/v2/components/pages/landing-pages/cheap-storage-places-page'
import { LANDING_PAGES_META_CONTENTS } from '@/v2/constants/pages/landing-pages/meta/landing-pages-meta-content'
import { metaImages, ogImages } from '@/v2/constants/pages/landing-pages/cheap-storage-places-page'

interface CheapStoragePlacesPageProps {}

const Page: React.FC<CheapStoragePlacesPageProps> = () => {
  return (
    <>
      <Meta
        title={
          LANDING_PAGES_META_CONTENTS.cheap_storage_places.title ?? LANDING_PAGES_META_CONTENTS.default?.title ?? ''
        }
        keywords={
          LANDING_PAGES_META_CONTENTS.cheap_storage_places?.keywords ??
          LANDING_PAGES_META_CONTENTS.default?.keywords ??
          ''
        }
        description={
          LANDING_PAGES_META_CONTENTS.cheap_storage_places?.description ??
          LANDING_PAGES_META_CONTENTS.default?.description ??
          ''
        }
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
      />

      <CheapStoragePlacesPage />
    </>
  )
}

export default Page
